import React from "react";

import RadicalLineBackgroundImg from "../assets/RadicalLineBackground.svg";

export function RadicalLineBackground() {
  return (
    <div className="absolute pointer-events-none h-[1120px] right-[-100px] top-[-50px] w-[1146px] max-md:right-[-350px] max-md:top-[-150px] max-md:scale-75 max-sm:scale-52 max-sm:right-[-500px] max-sm:top-[-150px]">
      <img
        src={RadicalLineBackgroundImg}
        alt="Radical background graphic with circular and linear elements"
        className="lines-graphic"
        width={1043}
        height={534}
      />
    </div>
  );
}

export default RadicalLineBackground;
